<div class="dialog-header">
  <h2 mat-dialog-title>Указать статус на рассмотрении</h2>
  <button mat-icon-button (click)="close()" class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <div class="app-info">
    <p><strong>Заявка №:</strong> {{ data.application.applicationNumber }}</p>
    <p><strong>Компания:</strong> {{ data.application.companyName }}</p>
  </div>

  <form class="form-content">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Причина</mat-label>
      <textarea matInput [(ngModel)]="reason" name="reason" rows="3" required></textarea>
    </mat-form-field>
  </form>

  @if (errorMessage()) {
    <div class="error-message">{{ errorMessage() }}</div>
  }
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button mat-button (click)="close()">Отмена</button>
  <button mat-raised-button color="primary"
          (click)="submit()"
          [disabled]="!reason || loading()">
    @if (loading()) {
      <mat-spinner diameter="20"></mat-spinner>
    } @else {
      Сохранить
    }
  </button>
</mat-dialog-actions>
